export var ReservationDriverAttachmentType;
(function (ReservationDriverAttachmentType) {
    ReservationDriverAttachmentType["IDPCover"] = "IDP_COVER";
    ReservationDriverAttachmentType["IDPInfo"] = "IDP_INFO";
    ReservationDriverAttachmentType["PassportCover"] = "PASSPORT_COVER";
    ReservationDriverAttachmentType["PassportInfo"] = "PASSPORT_INFO";
    ReservationDriverAttachmentType["LicenseFront"] = "LICENSE_FRONT";
    ReservationDriverAttachmentType["LicenseBack"] = "LICENSE_BACK";
    ReservationDriverAttachmentType["Selfie"] = "SELFIE";
    ReservationDriverAttachmentType["Insurance"] = "INSURANCE";
    // ERP 추가 서류 (중복 허용)
    ReservationDriverAttachmentType["ERPAdditional"] = "ERP_ADDITIONAL";
})(ReservationDriverAttachmentType || (ReservationDriverAttachmentType = {}));
